import { render, staticRenderFns } from "./DrivingForm.vue?vue&type=template&id=c72f682e"
import script from "./DrivingForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrivingForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports